// > https://stackoverflow.com/a/28633515/8995887
export const getOffsetToScrollOnTopOfPage = () => {
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
}
